import Pricing from "@/components/sections/Pricing";
import ROICalculator from "@/components/sections/ROICalculator";

export default function PricingPage() {
  return (
    <>
      <section className="pt-12 pb-4 relative">
        <div className="absolute inset-0 dot-grid opacity-20 pointer-events-none" />
        <div className="container-x reveal">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Pricing</div>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-3xl">
            Simple, scalable pricing for every operation size.
          </h1>
          <p className="mt-5 text-lg text-[#94A3B8] max-w-2xl">
            Custom-quoted based on markets, team size, and integrations. No surprises.
          </p>
        </div>
      </section>
      <Pricing />
      <ROICalculator />
    </>
  );
}
